import { useState } from "react";
import { authService } from "../services/authService";

export const useForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({
    loading: false,
    success: false,
    message: "",
  });

  const handleSubmit = async () => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email.trim())) {
      return setStatus({
        loading: false,
        success: false,
        message: "Please enter a valid email address.",
      });
    }

    setStatus({ loading: true, success: false, message: "" });


    try {
      const res = await authService.forgotPassword(email);
      const { success, message } = res;

      if (!success) {
        setStatus({ loading: false, success: false, message });
      } else {
        setStatus({ loading: false, success: true, message: "" });
      }
    } catch (err) {
      setStatus({
        loading: false,
        success: false,
        message:
          err.response?.data?.message ||
          "Connectivity issue. Please try again.",
      });
    }
  };

  return { email, setEmail, status, handleSubmit };
};
